<!-- Avisos -->
<div *ngIf="matriculas?.length !== 0 || cambioPcf?.length !== 0" class="row">

    <div class="container-desplegable-alertas">

        <div class="col-md-12">
            <div class="card card-accent-success animated fadeIn">

                <a class="card-header-a bg-warning margin-card-alerta" (click)="isCollapsedAvisos = !isCollapsedAvisos" [attr.aria-expanded]="!isCollapsedAvisos" aria-controls="collapseExample" title="Solicitudes con las mismas matrículas incluidas">
                    <div class="card-header-alertas">
                        <i class="fa fa-list"></i> Avisos <div class="contador"><h7>{{totalCountAvisos}}</h7></div>
                        <i *ngIf="isCollapsedAvisos" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsedAvisos" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>

                <div class="collapse group-filtros" id="collapsedAvisos" [ngbCollapse]="isCollapsedAvisos">
                    <div class="card-body-detalle">
                        <div class="row row-alerta">
                            <table class="table table-responsive table-sm">
                                <thead class="col-md-12">

                                    <!--Solicitudes con matrículas utilizadas - Importación-->
                                    <tr class="alerta-rechazo" *ngIf="matriculas?.length !== 0">
                                        <th class="imagen-alerta"></th>
                                        <th class="margin-row-alerta" *ngFor="let matricula of arrayCodigosPorMatricula | keyvalue">
                                            <h6 title="Matrícula {{ matricula.key }} utilizada en la(s) solicitud(es): ">
                                                Matrícula {{ matricula.key }} utilizada en la(s) solicitud(es):
                                                <a *ngFor="let codigoMatricula of matricula.value" title="Redirección a solicitud: {{ codigoMatricula.Codigo }}" (click)="redirectImport(codigoMatricula.IdSolicitud)">{{ codigoMatricula.Codigo }}</a>
                                            </h6>
                                        </th>
                                    </tr>

                                    <tr class="alerta-rechazo" *ngIf="cambioPcf?.length !== 0">
                                        <th class="imagen-alerta"></th>
                                        <th class="margin-row-alerta" *ngFor="let item of cambioPcf">
                                            <h6 title="Cambio de Pcf">
                                                Solicitud de inspección documental recibida en
                                                <strong>{{item.PcfOrigen}}</strong>
                                                ha sido asignada a
                                                <strong>{{item.PcfSeleccionado}}</strong>,
                                                a través del modo de
                                                <strong>Asignación</strong>
                                                <strong>{{ getModoReasignacion(item) }}</strong>
                                                de Solicitudes
                                            </h6>
                                        </th>
                                    </tr>

                                </thead>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>

</div>

<!-- Rechazos -->
<div *ngIf="rechazo || rechazosMat?.length !== 0 || rechazoEx" class="row">

    <div class="container-desplegable-alertas">

        <div class="col-md-12">
            <div class="card card-accent-success animated fadeIn">

                <a class="card-header-a bg-danger margin-card-alerta" (click)="isCollapsedRechazos = !isCollapsedRechazos" [attr.aria-expanded]="!isCollapsedRechazos" aria-controls="collapseExample" title="Solicitudes con produtos y/o matrículas rechazados/as">
                    <div class="card-header-alertas">
                        <i *ngIf="rechazo || rechazosMat?.length !== 0" class="fa fa-list"></i> Rechazos
                        <div *ngIf="rechazo || rechazosMat?.length !== 0" class="contador"><h7>{{totalCountRechazos}}</h7></div>
                        <div *ngIf="rechazoEx" class="contador"><h7>{{totalCountRechazosEx}}</h7></div>
                        <i *ngIf="isCollapsedRechazos" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsedRechazos" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>

                <div class="collapse group-filtros" id="collapsedRechazos" [ngbCollapse]="isCollapsedRechazos">
                    <div class="card-body-detalle">
                        <div class="row row-alerta">
                            <table class="table table-responsive table-sm">
                                <thead class="col-md-12">

                                    <!--Solicitud con productos rechazados - Importación-->
                                    <tr class="alerta-rechazo" *ngIf="rechazo">
                                        <th class="imagen-alerta-rechazo"></th>
                                        <th class="margin-row-alerta">
                                            <h6 title="Solicitud con producto(s) similar(es) rechazado(s): ">Solicitud con producto(s) similar(es) rechazado(s):<a title="Redirección a solicitud: {{rechazo.Codigo}}" (click)="redirectImport(rechazo.IdSolicitud)">{{rechazo.Codigo}}</a></h6>
                                        </th>
                                    </tr>

                                    <!--Solicitudes con matrículas rechazadas - Importación-->
                                    <tr class="alerta-rechazo" *ngIf="rechazosMat?.length !== 0">
                                        <th class="imagen-alerta-rechazo"></th>
                                        <th class="margin-row-alerta" *ngFor="let rechazoXMatricula of arrayCodigosPorMatriculaRechazada | keyvalue">
                                            <h6 title="Solicitudes con la matrícula {{ rechazoXMatricula.key }} rechazada: ">
                                                Solicitudes con la matrícula {{ rechazoXMatricula.key }} rechazada:
                                                <a *ngFor="let rechazo of rechazoXMatricula.value" title="Redirección a solicitud: {{ rechazo.Codigo }}" (click)="redirectImport(rechazo.IdSolicitud)">{{ rechazo.Codigo }}</a>
                                            </h6>
                                        </th>
                                    </tr>

                                    <!--Solicitud con productos rechazados - Exportación-->
                                    <tr class="alerta-rechazo" *ngIf="rechazoEx">
                                        <th class="imagen-alerta-rechazo"></th>
                                        <th class="margin-row-alerta">
                                            <h6 title="Solicitud con producto(s) similar(es) rechazado(s): ">Solicitud con producto(s) similar(es) rechazado(s):<a title="Redirección a solicitud: {{rechazoEx.Codigo}}" (click)="redirectExport(rechazoEx.IdSolicitudEx)">{{rechazoEx.Codigo}}</a></h6>
                                        </th>
                                    </tr>

                                </thead>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>

</div>

<!--Enlaces-->
<div *ngIf="showEnlaces" class="row">

    <div class="container-desplegable-alertas">

        <div class="col-md-12">
            <div class="card card-accent-success animated fadeIn">

                <a class="card-header-a bg-info margin-card-alerta" (click)="isCollapsedEnlaces = !isCollapsedEnlaces" [attr.aria-expanded]="!isCollapsedEnlaces" aria-controls="collapseExample" title="Enlaces">
                    <div class="card-header-alertas">
                        <i class="fa fa-list"></i> Enlaces <div class="contador"><h7>{{totalCountEnlaces}}</h7></div>
                        <i *ngIf="isCollapsedEnlaces" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsedEnlaces" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>

                <div class="collapse group-filtros" id="collapsedEnlaces" [ngbCollapse]="isCollapsedEnlaces">
                    <div class="card-body-detalle">
                        <div class="row row-alerta">
                            <table class="table table-responsive table-sm">
                                <thead class="col-md-12">

                                    <!--Atestaciones-->
                                    <tr class="alerta-rechazo" *ngIf="claveSolicitudAtestFitoCollection?.length !== 0">
                                        <th class="imagen-alerta-enlace"></th>
                                        <th class="margin-row-alerta" *ngFor="let atestacion of claveSolicitudAtestFitoCollection">
                                            <h6 title="Atestaciones: ">
                                                Atestaciones:
                                                <a title="Redirección a solicitud: {{ atestacion.RefAtestFito }}" (click)="redirectAtestaciones(atestacion.IdSolicitudAtestFito)">
                                                    {{ atestacion.RefAtestFito }}
                                                </a>
                                            </h6>
                                        </th>
                                    </tr>

                                    <!--Solicitud Anul/Sust-->
                                    <tr class="alerta-rechazo" *ngIf="mensajeSolicitudAnulSust !== ''">
                                        <th class="imagen-alerta-enlace"></th>
                                        <th class="margin-row-alerta">
                                            <h6 title="{{ mensajeSolicitudAnulSust }}">{{ mensajeSolicitudAnulSust }}<a title="Redirección a solicitud: {{solicitudPadreAnulSust?.NumeroCertificado}}" (click)="redirectSolAnulSust(solicitudPadreAnulSust.NumeroCertificado)">{{solicitudPadreAnulSust?.NumeroCertificado}}</a></h6>
                                        </th>
                                    </tr>

                                    <!--Rechazo Parcial Hijas-->
                                    <tr class="alerta-rechazo" *ngIf="haySolHijaRechazoParcial && solicitudesHijasRechazoParcialCollection?.length !== 0">
                                        <th class="imagen-alerta-enlace"></th>
                                        <th class="margin-row-alerta">
                                            <h6 title="Rechazo Parcial: ">
                                                <span class="validParcial">Parcialmente validado desde:</span>
                                                <a title="Redirección a solicitud: {{ solicitudesHijasRechazoParcialCollection[0].Codigo }}" (click)="redirectSolHijasRechazoParcial(solicitudesHijasRechazoParcialCollection[0].Id)">
                                                    {{ solicitudesHijasRechazoParcialCollection[0].Codigo }}
                                                </a>
                                            </h6>
                                            <h6 title="Rechazo Parcial: ">
                                                <span class="rejectParcial">Parcialmente rechazado desde:</span>
                                                <a title="Redirección a solicitud: {{ solicitudesHijasRechazoParcialCollection[1].Codigo }}" (click)="redirectSolHijasRechazoParcial(solicitudesHijasRechazoParcialCollection[1].Id)">
                                                    {{ solicitudesHijasRechazoParcialCollection[1].Codigo }}
                                                </a>
                                            </h6>
                                        </th>
                                    </tr>
                                    <!--Rechazo Parcial Padre-->
                                    <tr class="alerta-rechazo" *ngIf="haySolPadreRechazoParcial">
                                        <th class="imagen-alerta-enlace"></th>
                                        <th class="margin-row-alerta">
                                            <h6 title="Rechazo Parcial: ">
                                                <span class="originalParcial">Solicitud Original (Rechazada Parcialmente):</span>
                                                <a title="Redirección a solicitud: {{ solicitudPadreRechazoParcial.Codigo }}" (click)="redirectSolPadreRechazoParcial(solicitudPadreRechazoParcial.Id)">
                                                    {{ solicitudPadreRechazoParcial.Codigo }}
                                                </a>
                                            </h6>
                                        </th>
                                    </tr>
                                    <!--Solicitud "Traslado" Padre-->
                                    <tr class="alerta-rechazo" *ngIf="haySolTrasladoPadre">
                                        <th class="imagen-alerta-enlace"></th>
                                        <th class="margin-row-alerta">
                                            <h6 title="Solicitud de tipo Traslado que se finaliza: ">
                                                <span class="originalParcial">Solicitud de tipo Traslado que se finaliza:</span>
                                                <a title="Redirección a solicitud: {{ solicitudTrasladoPadre.Codigo }}" (click)="redirectSolTrasladoPadre(solicitudTrasladoPadre.Id)">
                                                    {{ solicitudTrasladoPadre.Codigo }}
                                                </a>
                                            </h6>
                                        </th>
                                    </tr>

                                    <!--Solicitud "Normal" Hija-->
                                    <tr class="alerta-rechazo" *ngIf="haySolHijaNormal">
                                        <th class="imagen-alerta-enlace"></th>
                                        <th class="margin-row-alerta">
                                            <h6 title="Solicitud de tipo Normal que finaliza el traslado: ">
                                                <span class="originalParcial">Solicitud de tipo Normal que finaliza el traslado:</span>
                                                <a title="Redirección a solicitud: {{ solicitudNormalHija.Codigo }}" (click)="redirectSolNormalHija(solicitudNormalHija.Id)">
                                                    {{ solicitudNormalHija.Codigo }}
                                                </a>
                                            </h6>
                                        </th>
                                    </tr>

                                </thead>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>

</div>
